import React from 'react';
import Hyperlink from '../../../components/atoms/Hyperlink/Hyperlink';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SkipLink, SkipLinkTarget } from '../SkipLink';

const mapNonAlpha = '0-9';
const characters = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  mapNonAlpha,
];

type AToZCharacterNavigation = {
  pageListAToZ: any;
  invisibleHeadline: string;
  characterHint: string;
};
export function AToZCharacterNavigation({ pageListAToZ, invisibleHeadline, characterHint }: AToZCharacterNavigation) {
  const { t } = useSonTranslation('AToZContainer');

  /**
   * linked char that jumps to the AToZNavButton
   */
  const renderLinkedCharacterItem = (character: string) => {
    return (
      <li key={`character-${character}`} className="a-to-z-container__navigation-character">
        <Hyperlink
          to={`#char-${character}`}
          id={`navigation-item-${character}`}
          className="a-to-z-container__character font-bold-15-19 a-to-z-container__navigation-link"
        >
          <span className="invisible">{characterHint}</span>
          {character.toUpperCase()}
        </Hyperlink>
      </li>
    );
  };

  /**
   * Non linked Char, only for visual representation -> designs reason.
   * Screen reader know its an alphabetical list, so we hide non linked char for them.
   */
  const renderCharacterItem = (character: string) => {
    return (
      <li key={`character-${character}`} className="a-to-z-container__navigation-character" aria-hidden>
        <span className="a-to-z-container__character font-bold-15-19 a-to-z-container__navigation-no-link">
          {character.toUpperCase()}
        </span>
      </li>
    );
  };

  return (
    <div className="a-to-z-container__navigation-container">
      <h2 className="invisible">{invisibleHeadline}</h2>
      <SkipLink id="a-to-z-container-navigation-bottom">{t('skipList')}</SkipLink>
      {/* ul is never empty because characters is always present */}
      <ul className="a-to-z-container__navigation" id="a-to-z-container-navigation">
        {characters.map(character =>
          Object.keys(pageListAToZ).includes(character.toLowerCase())
            ? renderLinkedCharacterItem(character)
            : renderCharacterItem(character),
        )}
      </ul>
      <SkipLinkTarget targetName={t('skipListTarget')} id="a-to-z-container-navigation-bottom" />
    </div>
  );
}
